// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LabelInput-module-colorBubble {
  background-color: var(--button);
  border-radius: 100%;
  width: 15px;
  height: 15px;
  padding: 0;
  display: flex;
  flex-shrink: 0;
}

.LabelInput-module-inputContainer {
  display: flex;
  width: 100%;
  border-radius: 5px;
  border: 1px solid var(--border);
  padding: var(--input-padding);
  box-sizing: border-box;
  background-color: var(--background-input);
  font-weight: 100;
  font-size: 16px;
  gap: 10px;
  flex-wrap: wrap;
}

.LabelInput-module-inputContainer > ul {
  display: flex;
  margin: 0;
  padding: 0;
  list-style: none;
  flex-shrink: 0;
  gap: 10px;
  width: 100%;
  flex-wrap: wrap;
}

.LabelInput-module-inputContainer > ul > li:last-of-type {
  flex-grow: 1;
}

.LabelInput-module-inputContainer > ul > li > input {
  border: none;
  background-color: transparent;
  padding: 0;
}

.LabelInput-module-inputSuperContainer {
  position: relative;
}

.LabelInput-module-results {
  position: fixed;
  background-color: var(--background);
  padding: 0;
  list-style: none;
  width: calc(100% - 30px);
  margin: 15px 0 0;
  border-radius: 5px;
  overflow: hidden;
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
  z-index: 1;
  box-sizing: border-box;
  overflow: auto;
  max-height: 184px;
}

.LabelInput-module-results > li {
  margin: 5px;
}

.LabelInput-module-results button {
  width: 100%;
  text-align: left;
  align-items: center;
  display: flex;
  background-color: var(--background);
  color: var(--text);
  gap: 10px;
  border-radius: 5px;
}

.LabelInput-module-results button:hover {
  box-shadow: var(--box-shadow-default);
}

.LabelInput-module-results button .material-icons {
  font-size: 14px;
}`, "",{"version":3,"sources":["webpack://./src/components/LabelInput/LabelInput.module.css"],"names":[],"mappings":"AAAA;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,kBAAkB;EAClB,+BAA+B;EAC/B,6BAA6B;EAC7B,sBAAsB;EACtB,yCAAyC;EACzC,gBAAgB;EAChB,eAAe;EACf,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,6BAA6B;EAC7B,UAAU;AACZ;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,mCAAmC;EACnC,UAAU;EACV,gBAAgB;EAChB,wBAAwB;EACxB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,4CAA4C;EAC5C,UAAU;EACV,sBAAsB;EACtB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,mCAAmC;EACnC,kBAAkB;EAClB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,eAAe;AACjB","sourcesContent":[".colorBubble {\n  background-color: var(--button);\n  border-radius: 100%;\n  width: 15px;\n  height: 15px;\n  padding: 0;\n  display: flex;\n  flex-shrink: 0;\n}\n\n.inputContainer {\n  display: flex;\n  width: 100%;\n  border-radius: 5px;\n  border: 1px solid var(--border);\n  padding: var(--input-padding);\n  box-sizing: border-box;\n  background-color: var(--background-input);\n  font-weight: 100;\n  font-size: 16px;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n.inputContainer > ul {\n  display: flex;\n  margin: 0;\n  padding: 0;\n  list-style: none;\n  flex-shrink: 0;\n  gap: 10px;\n  width: 100%;\n  flex-wrap: wrap;\n}\n\n.inputContainer > ul > li:last-of-type {\n  flex-grow: 1;\n}\n\n.inputContainer > ul > li > input {\n  border: none;\n  background-color: transparent;\n  padding: 0;\n}\n\n.inputSuperContainer {\n  position: relative;\n}\n\n.results {\n  position: fixed;\n  background-color: var(--background);\n  padding: 0;\n  list-style: none;\n  width: calc(100% - 30px);\n  margin: 15px 0 0;\n  border-radius: 5px;\n  overflow: hidden;\n  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;\n  z-index: 1;\n  box-sizing: border-box;\n  overflow: auto;\n  max-height: 184px;\n}\n\n.results > li {\n  margin: 5px;\n}\n\n.results button {\n  width: 100%;\n  text-align: left;\n  align-items: center;\n  display: flex;\n  background-color: var(--background);\n  color: var(--text);\n  gap: 10px;\n  border-radius: 5px;\n}\n\n.results button:hover {\n  box-shadow: var(--box-shadow-default);\n}\n\n.results button :global(.material-icons) {\n  font-size: 14px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"colorBubble": `LabelInput-module-colorBubble`,
	"inputContainer": `LabelInput-module-inputContainer`,
	"inputSuperContainer": `LabelInput-module-inputSuperContainer`,
	"results": `LabelInput-module-results`
};
export default ___CSS_LOADER_EXPORT___;
